import React from "react";

export default function TopKTable(props: {
  title: string;
  columns: Array<{ key: string; label: string; mono?: boolean }>;
  rows: Array<Record<string, any>>;
}) {
  return (
    <div className="rounded-xl border bg-white p-4 shadow-sm overflow-auto">
      <div className="text-sm font-semibold">{props.title}</div>
      <table className="mt-3 min-w-full text-sm">
        <thead className="text-xs text-gray-500">
          <tr className="border-b">
            {props.columns.map((c) => (
              <th key={c.key} className="text-left py-2 pr-3">
                {c.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {props.rows.length === 0 ? (
            <tr>
              <td className="py-3 text-gray-500" colSpan={props.columns.length}>
                No data.
              </td>
            </tr>
          ) : (
            props.rows.map((r, idx) => (
              <tr key={idx} className="border-b last:border-b-0">
                {props.columns.map((c) => (
                  <td key={c.key} className={`py-2 pr-3 ${c.mono ? "font-mono text-xs" : ""}`}>
                    {r[c.key] ?? "—"}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}